module.exports = __webpack_public_path__ + "img/hever-welcome-header.b3262490.png";